import Idoc from "./helpers/Idoc";

require('moment/locale/it');

export default class MyStorage {
    async set(key, value, expired_at) {
        try {
            if (!expired_at) expired_at = null;
            if (expired_at) {
                if (expired_at instanceof Date) {
                    expired_at = moment(expired_at).format('YYYY-MM-DD HH:mm:ss');
                } else if (expired_at != Idoc.FLASH_DATA_STORAGE) {
                    expired_at = null;
                }
            }
            localStorage.setItem(key, JSON.stringify({
                expired_at: expired_at,
                data: value
            }));
            return true;
        } catch (reason) {

        }
        return false;
    }

    async get(key) {
            try {
                const result = localStorage.getItem(key);
                if (result != null) {
                    const obj = JSON.parse(result);
                    if (!obj || !obj.data) {
                        this.remove(key)
                        return null;
                    }
                    if (obj.expired_at && obj.expired_at == Idoc.FLASH_DATA_STORAGE) {
                        this.remove(key);
                    } else if (obj.expired_at) {
                        const data = moment(obj.expired_at, 'YYYY-MM-DD HH:mm:ss').toDate();

                        if (new Date() > data) {
                            this.remove(key);
                            return null;
                        }
                    }
                    return obj.data;
                }
            } catch (reason) {

            }
            return null;
        }
        // remove a single key value:
    remove(key) {
            localStorage.removeItem(key);
        }
        //  delete all data from your application:
    clear() {
        localStorage.clear();
    }
}